namespace RedBullMOBILE360.CVM {
    export interface SegmentCriteriaForm {
        SegmentId: Serenity.IntegerEditor;
        ConditionId: Serenity.IntegerEditor;
    }

    export class SegmentCriteriaForm extends Serenity.PrefixedContext {
        static formKey = 'CVM.SegmentCriteria';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!SegmentCriteriaForm.init)  {
                SegmentCriteriaForm.init = true;

                var s = Serenity;
                var w0 = s.IntegerEditor;

                Q.initFormType(SegmentCriteriaForm, [
                    'SegmentId', w0,
                    'ConditionId', w0
                ]);
            }
        }
    }
}
